import { render, staticRenderFns } from "./review-detail.vue?vue&type=template&id=b0b3b8da"
import script from "./review-detail.vue?vue&type=script&lang=js"
export * from "./review-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports